import React from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { isNullOrUndefined, setUrlToHTTPs } from '../utils';
import { AppConf } from '../AppConf';
import { useKeycloak } from '@nic-react/auth';
import { useAppendAuthorizationHeader } from '../utils/connector/api-connector';
import Spinner from '../components/Spinner/Spinner';
import { fillRequest } from '../components/Common';
import Request from '../model/Request';
import RequestView from '../components/RequestView/RequestView';
import { Bookings } from '../model/Bookings';


const RequestController = () => {
//    const {t} = useTranslation()
    const params = useParams()
  //  console.log('RequestCOntroller : ', params.id)
    const paramId = params.id
    const {keycloak} = useKeycloak()

    const header = useAppendAuthorizationHeader()


/*
    const buildAction = (request: Request) => {

        let res = null;
        if (keycloak && keycloak.tokenParsed) {
            let parsed: ExtendedTokenParsed = keycloak.tokenParsed;
            let isRegistry = parsed.registry;
            if (!isRegistry) {
                let contactDefined: boolean = !isNullOrUndefined(request.contact);

                let contactAction: string = contactDefined ? 'edit' : 'new';
                let ipDefined: boolean = !isNullOrUndefined(request.ipAddress);

                let ipAction: string = ipDefined ? 'edit' : 'new';
                res = (
                    <Button.Group>
                        <Button
                            onClick={() => {
                                //setShowModal(true)
                                //setModal(ModalChoice.ContactForm)
                                // console.log('Status: ', ipAction);
                            }}
                        >
                            <i className={'fal fa-address-card ant-button'}/>
                            <span style={{paddingLeft: '3px'}}>
                        {t(`request.contact.${contactAction}`)}
                    </span>
                        </Button>
                        <Button
                            onClick={() => {
                                // pushLink(, history, 'set');
                                //setModal(ModalChoice.IpForm)
                                //setShowModal(true)
                                // console.log('Status: ', status);
                                // console.log('Status: ', ipAction);
                            }}
                        >
                            <i className={'fal fa-globe ant-button'}/>
                            <span
                                style={{paddingLeft: '3px'}}
                            >
                                {t(`request.ip.${ipAction}`)}
                            </span>
                        </Button>

                    </Button.Group>
                );
            }
        }
        return res;
    }


*/


    const requestData = useQuery(
        {
            queryKey: ["requests", "request", `${paramId??''}`],
            queryFn: async () => {

                const {url: root} = AppConf.getRootUrl(keycloak.realm)

                const data =
                    await fetch(setUrlToHTTPs(`${root}/requests/${paramId}`), {...header})
                return data.json()
            }
        }
    )

    const bookingsData = useQuery(
        {
            queryKey: ["requests", "request", `${paramId??''}`, 'booking'],
            queryFn: async () => {

                const {url:root} = AppConf.getRootUrl(keycloak.realm)

                const data =
                    await fetch(setUrlToHTTPs(`${root}/requests/${paramId}/bookings`), {...header})
                return data.json()
            }
        }
    )

if (requestData.isError || bookingsData.isError) {
        return <span>Error</span>
    }


    if (requestData.isFetched && bookingsData.isFetched) {
        const request = new Request()
        const res = requestData.data

        fillRequest(request, res)
       // console.log('RequestController: Bookings: ', bookingsData.data, ' Request: ', request.links.testType)

        // Potrebbero non esserci prenotazioni
        const bookings = (bookingsData.data !== undefined && bookingsData.data.page.totalElements > 0)? new Bookings(bookingsData.data): undefined
        //console.log('Bookings2: ', bookings, bookingsData.data, bookingsData.data !== undefined && bookingsData.data.page.totalElements > 0)

        let links: Record<string, any> = {};
        const origLinks = request.links;
        if (!isNullOrUndefined(origLinks)) {
            // console.log('Request. Links');
            for (let link in origLinks) {
                if (link) {

                    let enabled = true;
                    let show = true;
                    let href = ((origLinks as any)[link] || {href: ''});
                    let message = '';
                    switch (link) {
                        case 'action:book': {
                            if (isNullOrUndefined(request.contact) ||
                                isNullOrUndefined(request.ipAddress)) {
                                message = 'request.action.book.disabled.message';
                                enabled = false;
                            }

                            break;
                        }
                        case 'bookings': {
                            break;
                        }
                        default: {
                            show = false;
                            break;
                        }
                    }
                    links[link] = {enabled: enabled, href: href.href, show: show, message: message};
                    // console.log('OriginLinks: ', link, origLinks[link]);
                }
            }
        }

        return (

                <RequestView
                    request={request}
                    bookings={bookings}
                />



        )
    }

    return (<Spinner/>)


}
export default RequestController